import React from 'react';
import { useMediaQuery } from 'react-responsive';
import numeral from 'numeraljs'
import { AiOutlineStop } from "react-icons/ai";
import { toast } from "react-toastify";

export function isValidPhoneNumber(text) {
    return /^9[1236][0-9]{7}$/.test(text);
}

export function useMobileMediaQuery() {
    return useMediaQuery({ query: '(min-width: 767px)' });
}

export function useMobileBtnBackMediaQuery() {
    return useMediaQuery({ query: '(max-width: 766px)' });
}

export function useUltraMobileMediaQuery() {
    return useMediaQuery({ query: '(min-width: 567px)' });
}

export function useTabletMediaQuery() {
    return useMediaQuery({ query: '(min-width: 1250px)' });
}

export function currencyFormat(num) {
    if (isNaN(num)) {
        return num;
    }

    num = Number(num) || 0;
    
    let formatted = numeral(num).format('0,0.00');
    return formatted.replace(/,/g, '_').replace(/\./g, ',').replace(/_/g, '.');
}

export function formatEuroAmount(amount) {
    const number = Math.round(parseFloat(amount) * 100);
    const euros = Math.floor(number / 100);
    const cents = (number % 100).toString().padStart(2, '0');
    return `${euros},${cents}`;
}

export function formatIbanPT (iban) {

    // Always enforce prefix
    if (!iban.startsWith("PT50")) {
        iban = "PT50" + iban.replace(/^PT50/, "");
    }

    // Remove all non-alphanumeric characters except PT50
    let clean = iban.replace(/[^A-Z0-9]/g, "");

    // Re-add PT50 prefix explicitly and remove the first 4 (PT50)
    let body = clean.slice(4);

    // Insert spaces every 4 characters
    const grouped = body.match(/.{1,4}/g)?.join(" ") ?? "";

    // Combine and trim total length to 29 characters max (PT50 + 25 chars + 5 spaces)
    const formatted = ("PT50 " + grouped).substring(0, 31);

    return formatted;
};

export function errorHandling(status) {
    switch (status) {
        case 401:
            toast.error("Não autorizado: Por favor, inicie novamente a sessão.", {
            icon: <AiOutlineStop />,
            });
            break;
        case 403:
            toast.error("Acesso rejeitado: Não tem permissão.", {
            icon: <AiOutlineStop />,
            });
            break;
        case 504:
            toast.error("O pedido expirou. Por favor, tente novamente.", {
            icon: <AiOutlineStop />,
            });
            break;
        case 500:
            toast.error("Ocorreu um erro inesperado. Por favor, tente novamente.", {
            icon: <AiOutlineStop />,
            });
            break;
        case 'NoInternet':
            toast.error("Sem ligação à Internet.", {
            icon: <AiOutlineStop />,
            });
            break;
        case 'CSRF':
            toast.error("Acesso rejeitado: Não tem permissão por motivos de segurança.", {
            icon: <AiOutlineStop />,
            });
            break;
        case '429':	
            toast.error("Acesso rejeitado: Não tem permissão por motivos de segurança.", {
            icon: <AiOutlineStop />,
            });
            break;
        case 'CORS':		
            toast.error("Acesso rejeitado CORS error: Não tem permissão por motivos de segurança.", {
            icon: <AiOutlineStop />,
            });
            break;
        default:
            toast.error("Ocorreu um erro inesperado. Por favor, tente novamente.", {
            icon: <AiOutlineStop />,
            });
            break;
    }
}